import React from 'react'

import { FormProvider, useForm } from 'react-hook-form'
import { observer } from 'mobx-react'
import { useParams } from 'react-router-dom'

import { useStores } from 'stores'

import Loader from 'common/Loader'
import LayoutTitle from 'common/LayoutTitle'
import MessageList from 'common/MessageList'
import Toaster from 'common/Toaster'

import OverbillInfo from './OverbillInfo'
import RejectOverbill from './RejectOverbill'

export default observer(() => {
  const { overbillStore, globalMessageStore } = useStores()
  const [showRejectForm, setShowRejectForm] = React.useState(false)
  const [approved, setApproved] = React.useState(false)
  const [rejected, setRejected] = React.useState(false)
  const { id: key } = useParams()
  const methods = useForm()
  const { handleSubmit } = methods

  const {
    CRUD: { loading, submitting },
  } = overbillStore

  const { piId, caseNumber, caseSubject, caseCurrency, overbill = {}, warningMessage, resource } = overbillStore.CRUD.data || {}
  const hasWarning = !!warningMessage
  const hasData = !hasWarning && !!piId

  React.useEffect(() => {
    key && overbillStore.getOverbillApproval(key)
  }, [overbillStore, key])

  const isRejecting = !loading && showRejectForm
  const disabled = submitting || approved || rejected

  const handleOnApprove = () => {
    const title = resource.ApproveOverbill
    Toaster.confirm({
      title,
      message: resource.ApproveConfirmationMessage,
      submitText: resource.Confirm,
      cancelText: resource.Cancel,
      closeOnSubmit: false,
      onSubmit: async closeModal => {
        const result = await overbillStore.approveOverbill(piId)
        closeModal()
        if (result) {
          setApproved(true)
          globalMessageStore.show({
            title,
            message: resource.ApproveSuccessMessage,
            color: 'success',
          })
        }
      },
    })
  }

  const handleOnReject = () => {
    setShowRejectForm(true)
  }

  const handleOnCancelReject = () => {
    setShowRejectForm(false)
  }

  const handleOnSubmitReject = async values => {
    const payload = {
      ...values,
    }
    const result = await overbillStore.rejectOverbill(piId, payload)
    if (result) {
      setRejected(true)
      globalMessageStore.show({
        title: resource.OverbillRejected,
        message: resource.RejectedMessage,
        color: 'success',
      })
    }
  }

  return (
    <div id="overbill">
      <Loader show={loading} className="justify-content-center" />
      {!isRejecting && (
        <div>
          <LayoutTitle title="Overbill" />
          {hasWarning && <MessageList messages={warningMessage && [warningMessage]} color="warning" />}
          {hasData && (
            <OverbillInfo
              caseNumber={caseNumber}
              caseSubject={caseSubject}
              caseCurrency={caseCurrency}
              overbill={overbill}
              handleOnApprove={handleOnApprove}
              handleOnReject={handleOnReject}
              disabled={disabled}
              approved={approved}
              rejected={rejected}
              resource={resource}
            />
          )}
        </div>
      )}
      {isRejecting && (
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(handleOnSubmitReject)} className="d-flex flex-column w-100">
            <LayoutTitle title={resource.rejectOverbill} />
            <RejectOverbill
              cancelReject={handleOnCancelReject}
              submitting={submitting}
              rejected={rejected}
              resource={resource}
            />
          </form>
        </FormProvider>
      )}
    </div>
  )
})
